module.exports = __webpack_public_path__ + "img/IMG_0689.d9892a84.jpg";